import { Component } from '@angular/core';

@Component({
    selector: 'app-landing-ab-test',
    templateUrl: './landing-ab-test.component.html',
    styleUrls: ['./landing-ab-test.component.css'],
    standalone: false
})
export class LandingAbTestComponent {
    isFamiliespage: boolean = false;
}
